import BrandModal from '@/common/atoms/BrandModal'
import useQueryParams from '@/common/hooks/useQueryParams'
import { SimpleGrid, useMediaQuery } from '@chakra-ui/react'
import React from 'react'
import LoginForm from '../components/LoginForm'
import SignupForm from '../components/SignupForm'
import settings, { isLocal } from 'src/settings'

type Params = {
  email: string
}

export default function AuthPage() {
  const queryParams = useQueryParams<Params>()
  const [isSmallScreen] = useMediaQuery('(max-width: 900px)')

  const handleClose = () => {
    window.open(settings.websiteUrl, '_self')
  }

  const Content = isLocal
    ? () => (
        <SimpleGrid columns={isSmallScreen ? 1 : 2} spacing="150px">
          <LoginForm defaultEmail={queryParams.email || ''} />
          <SignupForm defaultEmail={queryParams.email} />
        </SimpleGrid>
      )
    : () => <LoginForm defaultEmail={queryParams.email || ''} />

  return (
    <BrandModal
      size="4xl"
      bodyProps={{ mx: 10 }}
      isOpen
      trapFocus={false /* Allow password managers to work */}
      closeOnEsc={false}
      onClose={handleClose}
    >
      <Content />
    </BrandModal>
  )
}
